module.exports = __webpack_public_path__ + "img/bankCard.31953aed.svg";